// extracted by mini-css-extract-plugin
export var root = "y_tC";
export var wrapper = "y_tD";
export var image = "y_tF d_v d_x d_V";
export var crop = "y_tG";
export var round = "y_tH";
export var fixedHeight = "y_tJ";